export const ErrorNotFound = () =>{
    return(
        <>
            <p>Error, not found</p>
        </>
    )
}

export default ErrorNotFound;